import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'

interface SubtotalsType {
  [key:string]: {
    subtotal:number
    subtotal_text:string
  }
}

export const subtotalStore = defineStore('v2/subtotal', () => {
  const loading = ref(false)
  const subtotals = ref<SubtotalsType|null>(null)

  function getSubtotals () {
    loading.value = true
    axios.get(process.env.VUE_APP_API_URL_V2 + '/subtotals').then((r) => {
      subtotals.value = r.data
    }).finally(() => {
      loading.value = false
    })
  }

  return { loading, subtotals, getSubtotals }
})
